/** Snippet paths the importer dropped, surfaced so merchants can see what didn't come across. */
export class ImportWarnings {
  readonly paths: string[] = [];

  add(path: string): void {
    this.paths.push(path);
  }
}

const IDENTIFIER = /^[A-Za-z_$][\w$]*$/;

/** Extend `parent` with `key`, choosing dot or bracket notation the way the snippet would be written. */
export function childPath(parent: string, key: string | number): string {
  if (typeof key === 'number') return `${parent}[${key}]`;
  if (IDENTIFIER.test(key)) return parent === '' ? key : `${parent}.${key}`;
  return `${parent}[${JSON.stringify(key)}]`;
}

/** The segment naming the top-level option, e.g. `analytics` for `analytics.providers[0]`. */
export function topLevelKey(path: string): string {
  const match = /^[^.[]+/.exec(path);
  return match ? match[0] : path;
}
